/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_LayoutsInputs */

const cs_requirements_layouts = /** @type {(inputs: Requirements_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferované dispozice`)
};

const en_requirements_layouts = /** @type {(inputs: Requirements_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferred layouts`)
};

/**
* | output |
* | --- |
* | "Preferred layouts" |
*
* @param {Requirements_LayoutsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_layouts = /** @type {((inputs?: Requirements_LayoutsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_LayoutsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_layouts(inputs)
	return cs_requirements_layouts(inputs)
});